import { Popup, PopupProps } from '@innovyze/inno-map';
import React, { useState } from 'react';
import { PopupDetails } from './PopupDetails';
import { Feature } from './types';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const AssetPopup = (
	props: Omit<PopupProps<Feature[]>, 'children'>,
): JSX.Element => {
	const [assetType, setAssetType] = useState('wwManhole');

	const setTypeOfAsset = (aType: string) => {
		setAssetType(aType);
	};

	return (
		<Popup {...props} width={assetType == 'wwPipe' ? 450 : 400}>
			{features => {
				// filter out non-assets
				const feature = features.find(({ id }) => id.match('#'));
				if (!feature) return null;
				const [aType] = feature.id.split('#');
				setTypeOfAsset(aType);
				return <PopupDetails feature={feature} />;
			}}
		</Popup>
	);
};
